const selector = document.getElementById('variantInfoSelector')

const sections = Array.from(document.querySelectorAll('.product__info-item'))
if (selector) {
  selector.addEventListener('change', (e) => {
    const active = e.target.id

    sections
      .filter((elem) => elem.getAttribute('data-info') != active)
      .forEach((section) => section.classList.remove('active'))

    sections
      .find((elem) => elem.getAttribute('data-info') == active)
      .classList.add('active')
  })
}

function updateQueryString(key, value, url) {

  if (!url) {
    url = window.location.href
  }

  let updated = ''
  var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
    hash

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      updated = url.replace(re, '$1' + key + '=' + value + '$2$3')
    } else {
      hash = url.split('#')
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '')
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1]
      }
      updated = url
    }

  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?'
      hash = url.split('#')
      url = hash[0] + separator + key + '=' + value
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1]
      }
      updated = url
    } else {
      updated = url
    }
  }

  window.history.replaceState({ path: updated }, '', updated)
}
